export const UPDATE_PROGRAM  = 'UPDATE_PROGRAM';
export const TOGGLE_SETTINGS = 'TOGGLE_SETTINGS';